export enum GCCollectionTypeEnum {
  CantBuy = 'Não pode comprar',
  MustBuy = 'Deve comprar',
  Indifferent = 'Indiferente',
  OnlyInSet = 'Compra no conjunto',
}
